import React, { useState , useEffect } from "react";
import OrdenCard from "../tarjeta/OrdenCard.js";

// contexto de mesa donde esta almacenado el array inicial con las ordenes creadas desde layout productos
import { useMesa } from "../../../../contexto/provider/MesaContext.js";
import { useOrdenes } from "../../../../contexto/provider/OrdenesContext.js";

import SubTituloModulo from "../../../../componentsUI/estructura/tituloModulos/tituloSubModulo.js";
import "./OrdenLista.css";

export default function OrdenesLista() {
  // Contextos
  const { ordenesPorMesa, eliminarOrdenDeMesa } = useMesa();
  const { ordenesSeleccionadas, actualizarSeleccion } = useOrdenes();
  // Estado para mostrar popup de selección
  const [mostrarPopup, setMostrarPopup] = useState(false);
  const [mesaSeleccionadaPopup, setMesaSeleccionadaPopup] = useState(null);

  // Efecto para limpiar selección de ordenes que ya no existen
  useEffect(() => {
  if (!ordenesPorMesa || Object.keys(ordenesPorMesa).length === 0) {
    if (ordenesSeleccionadas.length > 0) {
      actualizarSeleccion([]);
    }
    return;
  }

  const ordenesValidas = [];

  Object.entries(ordenesPorMesa).forEach(([mesaId, ordenes]) => {
    ordenes.forEach((_, index) => {
      ordenesValidas.push(`${mesaId}-${index}`);
    });
  });

  const seleccionFiltrada = ordenesSeleccionadas.filter(
    (o) => ordenesValidas.includes(`${o.mesaId}-${o.index}`)
  );

  if (seleccionFiltrada.length !== ordenesSeleccionadas.length) {
    actualizarSeleccion(seleccionFiltrada);
  }
}, [ordenesPorMesa, ordenesSeleccionadas, actualizarSeleccion]);


  // Función para manejar selección/deselección de ordenes
  const handleSeleccionOrden = (mesaId, index) => {
      console.log("[Onclick Event] orden", { mesaId, index });

    const orden = { ...ordenesPorMesa[mesaId][index], mesaId, index };

    const yaSeleccionada = ordenesSeleccionadas.some(
      (o) => o.mesaId === mesaId && o.index === index,
    );

    let nuevasSeleccionadas;
    if (yaSeleccionada) {
      nuevasSeleccionadas = ordenesSeleccionadas.filter(
        (o) => !(o.mesaId === mesaId && o.index === index),
      );
    } else {
      nuevasSeleccionadas = [...ordenesSeleccionadas, orden];

      setMesaSeleccionadaPopup(mesaId);
      setMostrarPopup(true);
      setTimeout(() => {
        setMostrarPopup(false);
        setMesaSeleccionadaPopup(null);
      }, 1200);
    }

    actualizarSeleccion(nuevasSeleccionadas);
    console.log("[OrdenesContext] ordenesSeleccionadas:", ordenesSeleccionadas);
  };


return (
  <div className="ordenes-section">
    <SubTituloModulo subtitulo="Lista de órdenes por mesa" />

    <div className="contenedor-ordenes">
      {Object.entries(ordenesPorMesa).map(([mesaId, ordenes]) =>
        ordenes.map((orden, index) => (
          <OrdenCard
            key={`${mesaId}-${index}`}
            mesaId={mesaId}
            productos={orden.productos}
            total={orden.total}
            fecha={orden.fecha}
            seleccionada={ordenesSeleccionadas.some(
              (o) => o.mesaId === mesaId && o.index === index,
            )}
            onDelete={() => eliminarOrdenDeMesa(mesaId, index)}
            onSelected={() => handleSeleccionOrden(mesaId, index)}
          />
        )),
      )}
    </div>

    {mostrarPopup && mesaSeleccionadaPopup && (
      <div className="popup-mesa">
        {`Mesa ${mesaSeleccionadaPopup} seleccionada lista`}
      </div>
    )}
  </div>
);

}
